var _defs, _polygon, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudButRotateLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .rotatearrow {\n        fill: currentColor;\n      }\n\n      .rotatearrow, .rotateline {\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .rotateline {\n        fill: none;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "rotatearrow",
    points: "30.28 15.34 24.38 9.44 30.28 3.54 30.28 15.34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "rotateline",
    d: "M46.04,21.49h0c0-6.63-5.37-12-12-12h-6.65"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "rotateline",
    x: 3.96,
    y: 19.82,
    width: 32.91,
    height: 26.64,
    rx: 4.7,
    ry: 4.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudButRotateLine);
export default __webpack_public_path__ + "static/media/cloud_but_rotate_line.f10fbecba85b51119912045af2922789.svg";
export { ForwardRef as ReactComponent };